/*
export let defaultVariables = {
    url: "http://127.0.0.1:8000/api",
    backend: "http://127.0.0.1:8000/",
    uploads: "http://127.0.0.1:8000/uploads",
    React:"http://localhost:3000",
    website: "http://localhost:3000",
};
*/

export let defaultVariables = {
    url: "https://api.kolaydoy.org/api",
    backend: "https://api.kolaydoy.org/",
    uploads: "https://api.kolaydoy.org/uploads",
    React:"https://stock.kolaydoy.org",
    website: "https://stock.kolaydoy.org",
};
